{
  "title": "Игровое лобби",
  "subtitle": "Все игры из каталога Aggregator доступны здесь.",
  "searchPlaceholder": "Поиск игр",
  "categories": "Категории",
  "all": "Все",
  "slots": "Слоты",
  "live": "Живое казино",
  "crash": "Crash",
  "instant": "Instant",
  "table": "Столы",
  "other": "Другое",
  "popular": "Популярные",
  "new": "Новые",
  "jackpot": "Джекпот",
  "tags": "Фильтры",
  "providers": "Провайдеры",
  "emptyTitle": "Игры пока недоступны",
  "emptyBody": "Каталог провайдеров ещё не синхронизирован. Реальные и демо-игры включаются только после подтверждённой интеграции.",
  "errorTitle": "Не удалось загрузить каталог",
  "errorBody": "При получении списка игр произошла ошибка. Попробуйте позже.",
  "notPlayable": "Сейчас недоступно",
  "demoUnavailable": "Демо ещё не активно",
  "realMoneyDisabled": "Игры на реальные деньги отключены",
  "provider": "Провайдер",
  "results": "{{count}} игр",
  "featured": "Избранное",
  "lobbySection": "Каталог",
  "allProviders": "Все провайдеры",
  "sort": "Сортировка",
  "sortRecommended": "Рекомендуемые",
  "sortName": "Имя",
  "sortProvider": "Провайдер",
  "favorite": "Избранное",
  "selectWallet": "Выберите баланс перед игрой",
  "realBalance": "Основной баланс",
  "bonusBalance": "Бонусный баланс",
  "fundingLocked": "Выбранный баланс сохраняется на всю игровую сессию. Реальные и бонусные средства не смешиваются.",
  "launchPlay": "Играть",
  "bonusNotSlot": "Бонус можно использовать только в подтверждённых слотах",
  "bonusPlayDisabled": "Бонусная игра ещё не активна",
  "sessionFundingUnsupported": "Провайдер не может безопасно сохранить источник средств для сессии. Этот режим заблокирован.",
  "loginToPlay": "Войдите, чтобы играть",
  "sessionLaunched": "Игровая сессия создана",
  "loadMore": "Показать ещё",
  "loadingMore": "Загрузка…",
  "showingOf": "{{shown}} / {{total}} игр",
  "launchDemo": "ИГРАТЬ ДЕМО",
  "launchReal": "ИГРАТЬ НА РЕАЛЬНЫЙ БАЛАНС",
  "launchBonus": "ИГРАТЬ НА БОНУСНЫЙ БАЛАНС",
  "demoLaunched": "Демо-сессия создана",
  "history": "История игр",
  "searchResults": "Поиск",
  "bonusContinueTitle": "Продолжить с бонусом?",
  "bonusContinueBody": "Основной баланс 0. Есть бонус — только по вашему выбору.",
  "openExternal": "Открыть игру",
  "openExternalHint": "Если игра не открывается внутри, нажмите кнопку ниже.",
  "backToCatalog": "К каталогу",
  "notFound": "Игра не найдена",
  "recommended": "Рекомендуемые",
  "fastGames": "Быстрые игры",
  "bonusWager": "Ставка бонусом"
}
